export enum OpeningHourTypes {
    GENERAL = 'GENERAL',
    WORKSHOP = 'WORKSHOP',
    SALES = 'SALES',
    RECEPTION = 'RECEPTION',
    ADMINISTRATION = 'ADMINISTRATION',
    PLANNER = 'PLANNER',
}

export const defaultOpeningHourTypes = [
    OpeningHourTypes.GENERAL,
    OpeningHourTypes.WORKSHOP,
    OpeningHourTypes.SALES,
    OpeningHourTypes.RECEPTION,
    OpeningHourTypes.ADMINISTRATION,
];
